
import { lazy } from "react";

const ConsignmentManage = lazy(
  () => import("pages/ConsignmentManage/ConsignmentManage")
);
const LabelPrintRequest = lazy(
  () => import("pages/LabelPrintRequest/LabelPrintRequest")
);
const BarCodeManager = lazy(
  () => import("pages/BarCodeManager/BarCodeManager")
);
const Settlement = lazy(() => import("pages/Settlement"));
const ReturnConsignments = lazy(() => import("pages/ReturnConsignments"));
const LabelAllocate = lazy(() => import("pages/label-allocate/LabelAllocate"));

const PostBarcodeMatching = lazy(() => import("pages/post-barcode-matching"));
const ConsignmentDeliveryReport = lazy(
  () => import("pages/consignment-delivery-report")
);


const ChangeConsingmentsStatusToPost = lazy(
  () => import("pages/naja-consignment-scan")
);
export const childs: Array<ISideBarChild> = [
  {
    code: "",
    to: "/consignment-manage",
    component: <ConsignmentManage />,
    label: "مدیریت مرسوله",
    permissions: "view_consignment_management",
  },
  // {
  //   code: "",
  //   to: "/label-print-request",
  //   component: <LabelPrintRequest />,
  //   label: "درخواست چاپ برچسب",
  //   permissions: "view_request_label_print_request",
  // },
  {
    code: "",
    to: "/label-allocate",
    component: <LabelAllocate />,
    label: "تخصیص برچسب",
    permissions: "view_assign_label",
  },
  {
    code: "",
    to: "/barcode",
    component: <BarCodeManager />,
    label: "مدیریت بارکد",
    permissions: "view_label_management",
  },
  // {
  //   code: "",
  //   to: "/settlement",
  //   component: <Settlement />,
  //   label: "تسویه حساب",
  //   permissions: "view_settlement",
  // },
  // {
  //   code: "",
  //   to: "/return-consignment",
  //   component: <ReturnConsignments />,
  //   label: "مرسولات  برگشتی",
  //   permissions: "view_return_consignment",
  // },
  // {
  //   code: "",
  //   to: "/group-payment",
  //   component: <GroupPayment />,
  //   label: "واریز گروهی",
  //   permissions:"",
  // },
  // {
  //   code: "assignPostbarcde",
  //   to: "/post-barcode-matching",
  //   component: <PostBarcodeMatching />,
  //   label: "تطبیق بارکد پستی",
  //   permissions: "assignPostbarcde",
  // },
  {
    code: "",
    to: "/in-person-delivery-consingment",
    component: <ConsignmentDeliveryReport />,
    label: "مرسولات تحویل حضوری",
    permissions: "in_person_delivery",
  },
  // {
  //   code: "",
  //   to: "/change-consignment-status-to-post",
  //   component: <ChangeConsingmentsStatusToPost />,
  //   label: "مدیریت مرسولات ناجا",
  //   permissions: "view-naja-consignments-management",
  // },
];
